import './estatisticas.css';
import api from '../../services/cle';
import 'react-tabs/style/react-tabs.css';
import { useState, useEffect } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { useAppSelector } from '../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Button from '../../rxlib/components/buttons/button';
import InputLabel from '../../rxlib/components/input-label';
import { ApiError, LegendaOrigem } from '../../services/tipos';
import { Listagem } from '../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../rxlib/components/table';
import { usuarioTemPermissao } from '../../rxlib/services/seguranca';
import AcessoBloqueado from '../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../rxlib/components/layout/rxlib-Layout';
import { SelectLabel } from '../../rxlib/components/select/select-label';
import { ModalWarning } from '../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../rxlib/components/breadcrumb';
import { obterDataAtual, tratarErroApi } from '../../rxlib/services/utilitarios';
import { SelectLabelAsync } from '../../rxlib/components/select/select-label-async';

interface Filtros {
    origem: string;
    tipoData: string;
    dataFinal: string;
    dataInicial: string;
    idOrganizacao: string;
    chaveOrganizacao: string;
}

interface Aba {
    aba: string;
    campos: ConfiguracoesTabela,
    dados: [{ [key: string]: string; }];
}

function EstatisticasListagem() {
    const [itensOrigem, setItensOrigem] = useState<any>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [legendasOrigem, setLegendasOrigem] = useState<LegendaOrigem[]>([]);

    const dataAtualstring = obterDataAtual();
    const temPermissao = usuarioTemPermissao(token, 'estatisticas_consulta');

    const [filtros, setFiltros] = useState<Filtros>({
        origem: 'SEL',
        tipoData: '0',
        idOrganizacao: '',
        chaveOrganizacao: '',
        dataFinal: dataAtualstring,
        dataInicial: dataAtualstring,
    });

    const [abasOrigens, setAbasOrigens] = useState<Aba[]>([{
        aba: '',
        campos: {
            mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
            colunas: [],
        },
        dados: [{
        }],
    }]);

    const { register, handleSubmit } = useForm<Filtros>();

    const handleHide = () => setShowWarning(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Consulta de estatísticas', link: '' },
    ];

    const itensTipoData: any = [
        { id: 0, nome: 'Referência' },
        { id: 1, nome: 'Recebimento' },
    ];

    useEffect(() => {
        api.get('/LegendaOrigem/')
            .then((response: AxiosResponse<any>) => {
                setLegendasOrigem(response.data);

                const itensOrigem: any = [
                    {
                        id: 'SEL',
                        nome: 'Selecione'
                    },
                    {
                        id: 'ONI',
                        nome: 'Origem não identificada',
                    }
                ];

                for (let index = 0; index < response.data.length; index++) {
                    itensOrigem.push({
                        id: response.data[index].origem,
                        nome: getLegendaOrigem(response.data, response.data[index].origem),
                    });
                }

                setItensOrigem(itensOrigem);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }, []);

    useEffect(() => {
        if ((temPermissao) && (filtros.tipoData) && (filtros.chaveOrganizacao) && (filtros.dataInicial) && (filtros.dataFinal)) {
            setCarregando(true);
            api.get(getUrlConsulta())
                .then((response: AxiosResponse<any>) => {
                    let abas: Aba[] = [{
                        aba: '',
                        campos: {
                            mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
                            colunas: [],
                        },
                        dados: [{
                        }],
                    }];

                    setTimeout(() => {
                        carregarAbas(abas, response);
                        carregarDados(abas, response);
                        setAbasOrigens(abas);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
        }

        function carregarAbas(abas: Aba[], response: AxiosResponse<any>) {
            if (response.data.value.length > 0) {
                for (let indice: number = 0; indice < response.data.value.length; indice++) {
                    const legenda: string = getLegendaOrigem(legendasOrigem, response.data.value[indice].Origem);

                    if (abas.find(item => item.aba === legenda) === undefined) {
                        if (indice === 0) {
                            abas[0].aba = legenda;
                        } else {
                            abas.push({
                                aba: legenda,
                                campos: {
                                    mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
                                    colunas: [],
                                },
                                dados: [{
                                }],
                            });
                        }
                    }
                }
            }
        }

        function carregarDados(abas: Aba[], response: AxiosResponse<any>) {
            if (response.data.value.length > 0) {
                for (let indice: number = 0; indice < response.data.value.length; indice++) {
                    let dados = JSON.parse(response.data.value[indice].Dados.replaceAll("'", '"')).Estatisticas;

                    dados['DataRecebimento'] = response.data.value[indice].Data;
                    dados['DataReferencia'] = response.data.value[indice].DataReferencia;

                    let legenda: string = getLegendaOrigem(legendasOrigem, response.data.value[indice].Origem);

                    for (let indiceAba = 0; indiceAba < abas.length; indiceAba++) {
                        if (abas[indiceAba].aba === legenda) {

                            if ((abas[indiceAba].dados.length > 0) && (abas[indiceAba].dados[0]['DataRecebimento'] === undefined)) {
                                abas[indiceAba].dados[0] = dados;
                            } else {
                                abas[indiceAba].dados.push(dados);
                            }

                            if ((!abas[indiceAba].campos.colunas.find(campo => campo.nome === 'DataRecebimento'))) {
                                abas[indiceAba].campos.colunas.push({ nome: 'DataRecebimento', campo: 'DataRecebimento', tipo: 'date' });
                            }

                            if ((!abas[indiceAba].campos.colunas.find(campo => campo.nome === 'DataReferencia'))) {
                                abas[indiceAba].campos.colunas.push({ nome: 'DataReferencia', campo: 'DataReferencia', tipo: 'date' });
                            }

                            let campos = Object.getOwnPropertyNames(dados);
                            for (let indiceCampos = 0; indiceCampos < campos.length; indiceCampos++) {
                                if ((!abas[indiceAba].campos.colunas.find(campo => campo.nome === campos[indiceCampos]))) {
                                    abas[indiceAba].campos.colunas.push({ nome: campos[indiceCampos], campo: campos[indiceCampos], tipo: 'number' })
                                }
                            }

                            break;
                        }
                    }
                }
            }
        }

        function getUrlConsulta(): string {
            let url: string = `OData/Estatisticas?$filter=organizacao/chave eq '${filtros.chaveOrganizacao}'`;

            if (filtros.origem !== 'SEL') {
                if (filtros.origem === 'ONI') {
                    url += ' and origem eq \'\' ';
                } else {
                    url += ` and origem eq '${filtros.origem}'`;
                }
            }

            switch (filtros.tipoData) {
                case '0':
                    url += ` and date(dataReferencia) ge ${filtros.dataInicial} and date(dataReferencia) le ${filtros.dataFinal}`;
                    break;
                case '1':
                    url += ` and date(data) ge ${filtros.dataInicial} and date(data) le ${filtros.dataFinal}`;
                    break;
            }
            return url;
        }
    }, [temPermissao, filtros, legendasOrigem]);

    function getLegendaOrigem(legendasOrigem: LegendaOrigem[], origem: string): string {
        let legenda: string = '';

        if (legendasOrigem) {
            const legendaOrigem: LegendaOrigem | undefined = legendasOrigem.find(item => item.origem === origem);
            if (legendaOrigem) {
                legenda = legendaOrigem.legenda;
            }
        }

        if (legenda === '') {
            legenda = 'Origem não identificada';

            if (origem !== '') {
                legenda += ' (' + origem + ')';
            }
        }

        return legenda;
    }

    const onSubmit: SubmitHandler<Filtros> = data => {
        const dataFinal = new Date(data.dataFinal);
        const dataInicial = new Date(data.dataInicial);

        if ((data.tipoData === '1') && (dataInicial.getTime() > dataFinal.getTime())) {
            setMessageWarning(['Data inicial maior que a data final de recebimento.']);
            setShowWarning(true);
        } else if ((data.tipoData === '0') && (dataInicial.getTime() > dataFinal.getTime())) {
            setMessageWarning(['Data inicial maior que a data final de referência.']);
            setShowWarning(true);
        } else {
            obterChaveOrganizacao(data);
        }
    }

    function obterChaveOrganizacao(data: Filtros) {
        api.get(`/Organizacao/${data.idOrganizacao}`)
            .then(response => {
                setFiltros({
                    origem: data.origem,
                    tipoData: data.tipoData,
                    dataFinal: data.dataFinal,
                    dataInicial: data.dataInicial,
                    idOrganizacao: data.idOrganizacao,
                    chaveOrganizacao: response.data.chave,
                });
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }

    function tratarErro(error: AxiosError<ApiError>) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)} className='mb-1'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-3'>
                                <SelectLabelAsync
                                    action=''
                                    foco='sim'
                                    required='sim'
                                    type='Organizacao'
                                    label='Organização:'
                                    name='idOrganizacao'
                                    id='inputIdOrganizacao'
                                    className='rxlib-select-label-coluna'
                                    referencia={register({ required: true })} />
                            </div>
                            <div className='col-3'>
                                <SelectLabel
                                    action=''
                                    foco='nao'
                                    name='origem'
                                    required='nao'
                                    label='Origem:'
                                    id='inputOrigem'
                                    ariaLabel='origem'
                                    valorSelecionado=''
                                    itens={itensOrigem}
                                    campoExibicaoRegistro='nome'
                                    campoIdentificadorRegistro='id'
                                    className='rxlib-select-label-coluna'
                                    referencia={register({ required: false })} />
                            </div>
                            <div className='col-6' />
                        </div>
                        <div className='row px-1 mt-2'>
                            <div className='col-2'>
                                <SelectLabel
                                    action=''
                                    foco='nao'
                                    label='Data:'
                                    name='tipoData'
                                    id='inputTipoData'
                                    ariaLabel='tipoData'
                                    itens={itensTipoData}
                                    valorSelecionado={'0'}
                                    campoExibicaoRegistro='nome'
                                    campoIdentificadorRegistro='id'
                                    className='rxlib-select-label-coluna'
                                    referencia={register({ required: true })} />
                            </div>
                            <div className='col-2'>
                                <InputLabel
                                    type='date'
                                    maxLength={10}
                                    readOnly={false}
                                    id='dataInicial'
                                    autoFocus={false}
                                    name='dataInicial'
                                    label='Data inicial:'
                                    placeholder='  /  /    '
                                    defaultValue={dataAtualstring}
                                    className='rxlib-input-label-coluna'
                                    referencia={register({ required: true })} />
                            </div>
                            <div className='col-2'>
                                <InputLabel
                                    type='date'
                                    maxLength={10}
                                    id='dataFinal'
                                    readOnly={false}
                                    name='dataFinal'
                                    autoFocus={false}
                                    label='Data final:'
                                    placeholder='  /  /    '
                                    defaultValue={dataAtualstring}
                                    className='rxlib-input-label-coluna'
                                    referencia={register({ required: true })} />
                            </div>
                            <div className='col-2 rxlib-celula-botao'>
                                <Button
                                    type='submit'
                                    texto='Consultar'
                                    classStyle='btn-rxlib' />
                            </div>
                            <div className='col-4'>
                            </div>
                        </div>
                    </div>
                </form>
                <div className='container-fluid mb-5 mt-1'>
                    {
                        ((abasOrigens.length > 0) && (abasOrigens[0].aba !== ''))
                            ? <div className='row px-1 mt-3'>
                                <Tabs>
                                    <TabList>
                                        {
                                            abasOrigens.map((item, index) =>
                                                <Tab id={String(index)}>{item.aba}</Tab>
                                            )
                                        }
                                    </TabList>
                                    {
                                        abasOrigens.map((item, index) =>
                                            <TabPanel id={String(index)}>
                                                <Listagem
                                                    usarOrdenacao={true}
                                                    tipoBotaoAcao='button'
                                                    listagemDetalhe={false}
                                                    carregando={carregando}
                                                    fonteDados={item.dados}
                                                    campoId='DataRecebimento'
                                                    className='estatisticas-listagem'
                                                    configuracoesTabela={item.campos} />
                                            </TabPanel>
                                        )
                                    }
                                </Tabs>
                            </div>
                            : <div className='row px-3'>
                                <table className='table table-striped rxlib-table-overflow'>
                                    <thead>
                                        <tr>
                                            <th scope='col'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Não foram encontrados resultados para a consulta.</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    }
                </div>
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
            </RxlibLayout>
        </>
    );
}

export default EstatisticasListagem;